import classNames from "classnames";
import type { SwitchSize } from "./Switch";
import styles from "./Switch.module.scss";

interface SwitchIndicatorProps {
    checked: boolean;
    disabled?: boolean;
    /** Defaults to `sm`, the size menu and toggle rows use. */
    size?: SwitchSize;
    className?: string;
}

/**
 * Purely decorative switch for rows that toggle themselves (Picker toggle
 * items, filter rows): the row carries the semantics and the click target;
 * this only paints the design-system track and thumb.
 */
export const SwitchIndicator = ({
    checked,
    disabled = false,
    size = "sm",
    className,
}: Readonly<SwitchIndicatorProps>) => (
    <span
        aria-hidden="true"
        className={classNames(styles.switch, styles.indicator, className)}
        data-size={size}
        data-checked={checked ? "" : undefined}
        data-unchecked={checked ? undefined : ""}
        data-disabled={disabled ? "" : undefined}
    >
        <span className={styles.track}>
            <span className={styles.thumb} />
        </span>
    </span>
);
